export const ROUTE_PATHS = {
  HOME: '/home',
  BOTTOMSHEET: {
    EDIT_GOAL: '/bottomsheet/edit-goal',
  },
};

export const buildRoutePath = {};
